import { render, staticRenderFns } from "./ConsignmentActionSelector.vue?vue&type=template&id=7fb78b1a&scoped=true"
import script from "./ConsignmentActionSelector.vue?vue&type=script&lang=js"
export * from "./ConsignmentActionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb78b1a",
  null
  
)

export default component.exports